import * as Yup from 'yup';
import { AutomationActionType } from 'generated-graphql/types';

export const atsErrorMessage = 'ats-fields-required';

export const actionsValidationSchema = (campaignIdCanBeEmpty = false) =>
  Yup.object({
    automationTasks: Yup.array().of(
      Yup.object({
        action: Yup.object({
          type: Yup.string().required('Action type is required'),
          campaignId: campaignIdCanBeEmpty
            ? Yup.string().nullable()
            : Yup.string()
                .nullable()
                .when('type', {
                  is: AutomationActionType.SendCampaign,
                  then: (schema) => schema.required('Campaign is required')
                }),
          atsInterviewStageId: Yup.string().nullable(),
          atsRejectedReasonId: Yup.string().nullable()
        }).test(atsErrorMessage, atsErrorMessage, function (value) {
          if (value?.type === AutomationActionType.UpdateAts) {
            return Boolean(
              value.atsInterviewStageId || value.atsRejectedReasonId
            );
          }
          return true;
        })
      })
    )
  });
